export default "__VITE_ASSET__DFmutA1a__"